const hostname = window.location.hostname;
const isLocal = hostname === "localhost";

const API_BASE = isLocal
  ? "http://localhost:8080/api"
  : "https://courseecho.com/courseecho.be/public/api";

export const ENDPOINT = API_BASE;

// export const APPLYNOW: string = 'https://forms.gle/wKsQceyMSM9dYM8M7';
export const APPLYNOW: string = "/join-mentor";
